/// <reference path="../../../../../../../scripts/typings/sweetalert/sweetalert.d.ts" />
module Tapas.Bindings {
    export interface ISweetAlertArgs {
        // confirmation 
        observable: KnockoutObservable<any>;
        headLine?: string;
        text?: string;
        success?: string;
        confirmation?: boolean;
        confirmationText?: string;
        closeOnConfirm?: boolean;
        callBack?: any;
        confirmationButtonColor?: string;
        cancelButtonText?: string;
        // fail
        failHeadline?: string;
        failText?: string;
        failType?: string;
        //Succes
        successHeadline?: string;
        successText?: string;
        successType?: string;
        //Warning
        warningHeadline?: string;
        warningText?: string;
        warningType?: string;
    }
    export class SweetAlert {
        
        public update(element: any, valueAccessor: () => ISweetAlertArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
			var params = valueAccessor();
			var value = ko.unwrap(params.observable);

			if (value != ''){
				//Confirmation
				var callBack = params.callBack;
				var headline = params.headLine || 'Are you sure?'; // set a swal headline.
				var text = params.text || ''; // set a swal text.
				var type = params.success || 'warning'; // set the type of the swal "success"(default), "error" or "warning".
				var confirmation = params.confirmation || true; // control if you want a confirmation button
				var confirmationText = params.confirmationText || 'Ok'; // set confirmation text on button
				var closeOnConfirm = params.closeOnConfirm || true; // Close on confirm
				var confirmationButtonColor = params.confirmationButtonColor || '#DD6B55'; // Close on confirm
				var cancelButtonText = params.cancelButtonText || 'Annuller';
				//fail
				var failHeadline = params.failHeadline || '';
				var failText = params.failText || '';
				var failType = 'error';
				//succes
				var succesHeadline = params.successHeadline || '';
				var successText = params.successText || '';
				var successType = 'success';
				//warning
				var warningHeadline = params.warningHeadline || '';
				var warningText = params.warningText || '';
				var warningType = 'warning';

				// The user confirms then exit or confirms, on confirm run the callback function 
				if (value == 'confirmation') {
					swal({
						title: headline,
						text: text,
						type: type,
						showCancelButton: confirmation,
						confirmButtonColor: confirmationButtonColor,
						confirmButtonText: confirmationText,
						closeOnConfirm: closeOnConfirm,
						cancelButtonText: cancelButtonText
					},
					() => {
						callBack();
					});
				} 

				//The user recieves the fail info provided in the dom
				if (value == 'fail') {
					swal({
						title: failHeadline,
						text: failText,
						type: failType
					})
				}
				//The user recieves the success info in the dom
				if (value == 'success') {
					swal({
						title: succesHeadline,
						text: successText,
						type: successType
					})
				} 
				//The user recieves the warning info in the dom
				if (value == 'warning') {
					swal({
						title: warningHeadline,
						text: warningText,
						type: warningType
					})
				}
				params.observable('');
			}
        }
    }
    ko.bindingHandlers['sweetAlert'] = new SweetAlert();
} 